<template>
  <div class="container-custom">
    <v-form ref="form" @submit.prevent="saveHandler">
      <Breadscrumbs
        :links="[
          {
            name: 'TechnologyCenter',
            to: {
              name: 'TechnologyCenter'
            }
          },
          {
            name: 'Edit',
            to: {
              name: 'TechnologyEdit',
              params: {
                id: $route.params.id
              }
            }
          }
        ]"
      ></Breadscrumbs>
      <!-- page-actions -->
      <div class="page-actions">
        <h2>修改技術</h2>
        <v-spacer></v-spacer>
        <button class="btn mr-5" @click="cancelHandler">
          <span>取消</span>
        </button>
        <button class="btn btn-primary" type='submit'>
          <span>儲存</span>
        </button>
      </div>
    </v-form>
    <!-- Block 技術 -->
    <TechnologyCreateEdit></TechnologyCreateEdit>
    <LangDialog :isOpen.sync="isLangOpen" @confirm-submit="saveHandler()"></LangDialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import TechnologyCreateEdit from '@/views/E-7__Technology/c/TechnologyCreateEdit.vue';
import LangDialog from '@/components/LangSubmitDialog.vue';

export default {
  components: {
    Breadscrumbs,
    TechnologyCreateEdit,
    LangDialog,
  },
  data: () => ({
    isLangOpen: false,
  }),
  computed: {
    ...mapState(['lang']),
    ...mapState('technology', ['technology']),
  },
  async created() {
    if (this.$route.params.id) {
      await this.getTechnology(this.$route.params.id);
    }
  },
  methods: {
    ...mapActions('technology', {
      getTechnology: 'findById',
      save: 'save',
    }),
    cancelHandler() {
      this.$router.push({ name: 'TechnologyCenter' });
    },
    saveHandler() {
      if (this.isLangOpen || !this.lang.id) {
        this.errors = [];
        if (this.$refs.form.validate()) {
          if (!this.technology.title) {
            this.errors.push('標題 required.');
          } else if (!this.technology.slug) {
            this.errors.push('Slug required.');
          }
          if (this.errors.length > 0) {
            /* eslint-disable */
            alert(this.errors);
            /* eslint-disable */
            return false;
          }
          this.save(this.technology).then(() => {
            this.$router.push({ name: 'TechnologyCenter' });
          });
        }
      } else {
        this.isLangOpen = true;
      }
    },
  },
};
</script>

<style></style>
